import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './LegalPages.css';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      {/* Navbar */}
      <nav className="legal-navbar">
        <div className="legal-navbar-container">
          <Link to="/" className="legal-logo-link">
            <img
              src="/logo512.png"
              alt="Reveel Logo"
              className="legal-logo-image"
            />
          </Link>
          <Link to="/" className="legal-back-nav">
            {t('legal.backToHome')}
          </Link>
        </div>
      </nav>

      <div className="legal-content">
        <h1 className="legal-title">{t('privacyPolicy.title')}</h1>
        <div className="legal-prose">
          <p>{t('privacyPolicy.intro1')}</p>
          <p>{t('privacyPolicy.intro2')}</p>
          <p>{t('privacyPolicy.intro3')}</p>
          <p>{t('privacyPolicy.intro4')}</p>

          <h2>{t('privacyPolicy.infoCollection.title')}</h2>
          <p>{t('privacyPolicy.infoCollection.p1')}</p>
          <p>{t('privacyPolicy.infoCollection.p2')}</p>
          <p>{t('privacyPolicy.infoCollection.p3')}</p>
          <ul>
            <li><a href="https://supabase.com/privacy" target="_blank" rel="noopener noreferrer">Supabase</a></li>
            <li><a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noopener noreferrer">Apple Services</a></li>
          </ul>

          <h2>{t('privacyPolicy.healthData.title')}</h2>
          <p>{t('privacyPolicy.healthData.p1')}</p>
          <p>{t('privacyPolicy.healthData.p2')}</p>

          <h2>{t('privacyPolicy.logData.title')}</h2>
          <p>{t('privacyPolicy.logData.p1')}</p>

          <h2>{t('privacyPolicy.cookies.title')}</h2>
          <p>{t('privacyPolicy.cookies.p1')}</p>
          <p>{t('privacyPolicy.cookies.p2')}</p>

          <h2>{t('privacyPolicy.serviceProviders.title')}</h2>
          <p>{t('privacyPolicy.serviceProviders.p1')}</p>
          <ul>
            <li>{t('privacyPolicy.serviceProviders.reason1')}</li>
            <li>{t('privacyPolicy.serviceProviders.reason2')}</li>
            <li>{t('privacyPolicy.serviceProviders.reason3')}</li>
            <li>{t('privacyPolicy.serviceProviders.reason4')}</li>
          </ul>
          <p>{t('privacyPolicy.serviceProviders.p2')}</p>

          <h2>{t('privacyPolicy.security.title')}</h2>
          <p>{t('privacyPolicy.security.p1')}</p>

          <h2>{t('privacyPolicy.links.title')}</h2>
          <p>{t('privacyPolicy.links.p1')}</p>

          <h2>{t('privacyPolicy.children.title')}</h2>
          <p>{t('privacyPolicy.children.p1')}</p>

          <h2>{t('privacyPolicy.changes.title')}</h2>
          <p>{t('privacyPolicy.changes.p1')}</p>
          <p>{t('legal.effectiveDate')}</p>

          <h2>{t('privacyPolicy.contact.title')}</h2>
          <p>
            {t('privacyPolicy.contact.p1')}{' '}
            <a href="mailto:hello@reveel.health">hello@reveel.health</a>.
          </p>
        </div>
        <Link to="/" className="legal-back-link">
          ← {t('legal.backToHome')}
        </Link>
      </div>

      {/* Footer */}
      <footer className="legal-footer">
        <div className="legal-footer-container">
          <div className="legal-footer-logo">
            <img
              src="/logo512.png"
              alt="Reveel Logo"
            />
            <span>Reveel</span>
          </div>
          <div className="legal-footer-center">
            <Link to="/privacy-policy" className="legal-footer-link">{t('footer.privacy')}</Link>
            <Link to="/terms-and-conditions" className="legal-footer-link">{t('footer.terms')}</Link>
          </div>
          <p className="legal-footer-text">
            {t('footer.copyright')}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicyPage;
